import React from 'react';

import './Header.css';

function Header(props) {
	let classes = (props.classes) ?? "page-header";
	let parentClass = (props.classes)? 'article-header-container': 'header-container';
	return (
		<div className={parentClass}>
			<div className={classes}>
				{props.children}
			</div>
		</div>
	);
}

export default Header;